import Stack from '@mui/material/Stack'
import React from 'react'
import { EmptyPlaceholder } from '../../../../shared/components/EmptyPlaceholder'
import LinkedItemsListItem from './LinkedItemsListItem'
import { LinkingItem } from '../../Linking.types'
import { Group } from '../../Linking.types'
import Typography from '@mui/material/Typography'
import SvgIcon from '@mui/material/SvgIcon'

type LinkedItemsListProps<T> = {
    itemDisplayName: { singular: string; plural: string }
    items: LinkingItem<T>[]
    groups?: Group<T>[]
    getItemLinkingProps: (item: LinkingItem<T>) => { pathname: string; autoOpenData: object }
}

const LinkedItemsList = <T,>({ itemDisplayName, items, groups, getItemLinkingProps }: LinkedItemsListProps<T>) => {
    const isEmpty = !items?.length

    const renderItem = (item: LinkingItem<T>, index: number) => {
        return (
            <LinkedItemsListItem key={item._id} item={item} index={index} getItemLinkingProps={getItemLinkingProps} />
        )
    }

    return (
        <Stack direction="column" gap={2}>
            {isEmpty && (
                <Stack
                    flex={1}
                    direction="column"
                    gap={1}
                    px={2}
                    py={2.75}
                    bgcolor="figma.grayscale.tier7"
                    borderRadius="16px"
                >
                    <EmptyPlaceholder title="" subtitle={`No linked ${itemDisplayName.plural}`} />
                </Stack>
            )}
            {!isEmpty && !!groups?.length && (
                <Stack direction="column" gap={4.5}>
                    {groups.map((group) => (
                        <Stack key={group.id} direction="column" gap={2}>
                            <Stack direction="row" gap={1} alignItems="center">
                                {group.icon && (
                                    <SvgIcon
                                        component={group.icon}
                                        inheritViewBox
                                        fontSize="small"
                                        style={{
                                            fontSize: '14px',
                                        }}
                                    />
                                )}
                                <Stack direction="row" alignItems="center" gap={1.5}>
                                    <Typography variant="16x500" color="figma.grayscale.textHier1">
                                        {group.name}
                                    </Typography>
                                    <Typography variant="14x500" color="figma.grayscale.textHier2">
                                        {group.items.length} count
                                    </Typography>
                                </Stack>
                            </Stack>
                            {group.items.map(renderItem)}
                        </Stack>
                    ))}
                </Stack>
            )}
            {!isEmpty && !groups?.length && items.map(renderItem)}
        </Stack>
    )
}

export default LinkedItemsList
